import { useApi } from './api.mjs';
import { useSubscription } from './subscription.mjs';

/**
 * Returns the setting values defined by the merchant for the extension.
 */
function useSettings() {
  const settings = useSubscription(useApi().settings);
  return settings;
}

export { useSettings };
